import React from "react";
import "./SearchListItem.css";

const SearchListItem = ({
  name,
  distance,
  tag,
  type,
  description,
  free_cancel,
  price,
  rate,
  rate_text,
  image_url,
}) => {
  return (
    <div className="search-list-item">
      <img src={image_url} alt={name} className="img-list-item" />
      <div className="list-item-details">
        <div className="list-item-left">
          <h3 className="name-list-item">{name}</h3>
          <p>{distance} from center</p>
          <p className="tag-item">{tag}</p>
          <p className="description-item">{description}</p>
          <p>{type}</p>
          <div>
            {free_cancel ? (
              <div className="free-text">
                <p className="free-text-one">Free cancellation</p>
                <p className="free-text-tow">
                  You can cancel later, so lock in this great price today!
                </p>
              </div>
            ) : null}
          </div>
        </div>

        <div className="list-item-right">
          <div className="item-rate">
            <p className="rate-text">{rate_text}</p>
            <p className="rate-number-item">{rate}</p>
          </div>
          <p className="rate-price">${price}</p>
          <p className="text-frees">Includes taxes and fees</p>

          <button className="availability-button">See availability</button>
        </div>
      </div>
    </div>
  );
};

export default SearchListItem;
